export const initialMraOptions = {
    bright: 80,
    font: 2,
    width: 30,
};
//# sourceMappingURL=initialMraOptions.js.map